<div class="sso-callback d-flex align-items-center justify-content-center vh-100">
  <p class="text-muted">{{ 'LOGIN.SSO_SIGNING_IN' | translate }}</p>
</div>
